import { combineReducers } from 'redux';
import { consentsDictReducer } from './consents/reducer';
import { risksDictReducer } from './risks/reducer';

export const dictionariesReducer = combineReducers({
	consentsDict: consentsDictReducer,
	risksDict: risksDictReducer,
});
